import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { format, parseISO } from 'date-fns';

const FeedbackTrendChart = ({ feedbackByDate }) => {
  if (!feedbackByDate || Object.keys(feedbackByDate).length === 0) return <p>No data available</p>;

  // Convert to array and sort by date
  const data = Object.entries(feedbackByDate)
    .map(([dateStr, count]) => ({
      date: dateStr,
      count: count
    }))
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  return (
    <>
      <h3 className="chart-title">Feedback Trend</h3>
      <div className="chart-wrapper">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 20 }}>
            <defs>
              <linearGradient id="colorCount" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="var(--accent-color)" stopOpacity={0.3}/>
                <stop offset="95%" stopColor="var(--accent-color)" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--border-color)" />
            <XAxis 
              dataKey="date" 
              axisLine={false} 
              tickLine={false} 
              tick={{fill: 'var(--text-secondary)', fontSize: 12}} 
              tickFormatter={(tick) => format(parseISO(tick), 'MMM dd')}
            />
            <YAxis axisLine={false} tickLine={false} tick={{fill: 'var(--text-secondary)'}} />
            <Tooltip 
              cursor={{stroke: 'var(--border-color)', strokeWidth: 1, strokeDasharray: '3 3'}}
              contentStyle={{ borderRadius: '8px', border: '1px solid var(--border-color)', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}
              labelFormatter={(label) => format(parseISO(label), 'MMM dd, yyyy')}
            />
            <Area type="monotone" dataKey="count" stroke="var(--accent-color)" strokeWidth={3} fillOpacity={1} fill="url(#colorCount)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default FeedbackTrendChart;